var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShericardsbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 953,
    height: 613,
    viewBox: "0 0 953 613",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854.365 161.779L724.507 373.992C713.373 392.189 721.632 407.378 742.96 407.92L886.965 411.593C944.788 413.07 969.267 373.072 941.631 322.254L854.365 161.773L854.365 161.779Z",
    fill: "#F9C416"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.92 398.072L6.53864 540.748C-4.89843 552.982 -0.944422 565.966 15.3662 569.755L125.522 595.329C169.756 605.602 194.899 578.71 181.671 535.269L139.914 398.072L139.92 398.072Z",
    fill: "#1F225B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.293 575.171L573.937 387.522C559.933 371.435 542.964 374.746 536.028 394.92L489.228 531.161C470.43 585.864 501.223 621.238 557.999 610.157L737.293 575.176L737.293 575.171Z",
    fill: "#1F225B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.277 37.0171L389.633 224.666C403.637 240.753 420.606 237.442 427.542 217.268L474.343 81.0275C493.14 26.3241 462.347 -9.05001 405.571 2.03097L226.277 37.0118L226.277 37.0171Z",
    fill: "#F9C416"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShericardsbg);
export default __webpack_public_path__ + "static/media/shericardsbg.2ada8625c6b3b8a5e125a9e032e28d12.svg";
export { ForwardRef as ReactComponent };